var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#f3f6f9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25, 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 5 L45 5 L45 45 L5 45 L5 10 L25 10 Z",
    fill: "#cbd5e1",
    stroke: "#94a3b8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 8,
    height: 8,
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 15,
    width: 8,
    height: 8,
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 15,
    width: 8,
    height: 8,
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 8,
    height: 8,
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 26,
    width: 8,
    height: 8,
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 8,
    height: 8,
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 37,
    width: 12,
    height: 8,
    fill: "#475569"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyPlaceholder);
export default __webpack_public_path__ + "static/media/company-placeholder.62ec98fc3f485d49dc086ec1a873a83d.svg";
export { ForwardRef as ReactComponent };